import React from 'react'
import Home from '../../home/Home'
import UpdateAccount from '../../account-billing/account/UpdateAccount'

const UpdateAccountView = () => {
  return (
    <>
        <Home />
        <UpdateAccount/>
      </>
  )
}

export default UpdateAccountView
